import { IAnalyzeImageResponse } from '@src/api/types'
import axios from 'axios'

const api = axios.create({
    baseURL: '/api',
})

export const analyzeImage = (payload: FormData, signal?: AbortSignal) => {
    return api.post<IAnalyzeImageResponse>('/image_analyze', payload, {
        signal,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const analyzeImageByLink = (href_link: string, filename: string, signal?: AbortSignal) => {
    return api.post<IAnalyzeImageResponse>(
        '/image_analyze',
        {},
        {
            signal,
            params: {
                href_link,
                filename,
            },
        }
    )
}
